export default {
    eos_endpoint: 'https://eos.greymass.com',
    put_endpoint: 'https://rqjuv0hfzi.execute-api.us-east-1.amazonaws.com/prod',
    items_for_sale: {
        storage: 596224,
        cpu: 596721
    }
}